import { useEffect, useRef } from "react";
import {
  ReduxState,
  useCheckMinimumRequiredProps,
  useListContext,
} from "react-admin";
import { shallowEqual, useDispatch, useSelector } from "react-redux";

interface Props {
  resource?: string;
}

export const useResetListSearchField = (props: Props) => {
  useCheckMinimumRequiredProps("useResetListSearchField", ["resource"], props);
  const { filterValues } = useListContext();
  const dispatch = useDispatch();
  const listParams = useSelector(
    (x: ReduxState) => x.admin.resources[props.resource!]?.list?.params,
    shallowEqual
  );

  const effectExecuted = useRef<boolean>(false);
  useEffect(() => {
    if (effectExecuted.current) {
      return;
    }

    dispatch({
      type: "RA/CRUD_CHANGE_LIST_PARAMS",
      payload: {
        ...listParams,
        filter: { ...listParams.filter, ...filterValues, q: "" },
      },
      meta: {
        resource: props.resource,
      },
    });
    effectExecuted.current = true;
  }, [dispatch, props.resource, listParams, filterValues]);
};
